import React from 'react';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@crossnokaye/ux-common';

interface PreviewSectionProps {
  /** Section heading displayed in the accordion trigger (e.g. "Settings"). */
  title: string;
  /** Child components (typically `PreviewItem` rows) rendered inside the section. */
  children?: React.ReactNode;
}

/**
 * PreviewSection
 *
 * Accordion-based group that wraps related preview items under a collapsible title.
 * Expanded by default. Used to organize pending changes by category
 * (e.g. "Settings", "Sequencer Settings").
 */
export const PreviewSection = ({ title, children }: PreviewSectionProps): React.ReactElement => {
  return (
    <Accordion type="multiple" defaultValue={[title]}>
      <AccordionItem value={title}>
        <AccordionTrigger
          variant="small"
          title={title}
          className="pl-4 pr-2 bg-ckds-neutral-800 mb-thin"
        />
        <AccordionContent className="space-y-thin">{children}</AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
